import { FC } from 'react';
import type { HeroDefaultProps } from '.';

import LLMAnimation from 'react-scale/components/pages/llm/llm-animation';

export const contentType = {
  llma: <LLMAnimation />
};

export type HeroWithContent = {
  content: any;
  image: never;
  video: never;
  scene: never;
} & HeroDefaultProps;

const ContentAsset: FC<{
  content: HeroWithContent['content'];
}> = ({ content }) => {
  return <div className="w-full lg:w-auto">{contentType[content]}</div>;
};

export default ContentAsset;
